/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { useMediaQueries } from "@/shared";

import {
  colors,
  OBDIcon,
  TruckOutlineIcon
} from "@dotnet/telematics-design-system";

import BubbleWithText from "./BubbleWithText";
import MiddleSection from "./MiddleSection";

const TopDialogContent = () => {
  const { t } = useTranslation();

  const { toSm } = useMediaQueries();

  return (
    <div
      css={css({
        display: "flex",
        backgroundColor: colors.blue100,
        borderRadius: "8px",
        gap: "12px",
        height: "200px",
        justifyContent: "center",
        alignItems: "center"
      })}
    >
      <BubbleWithText
        isMobile={toSm}
        title={t("Dashboard##how credits work##top content##active vehicle")}
        subtitle={t(
          "Dashboard##how credits work##top content##identified by VIN"
        )}
        icon={<TruckOutlineIcon />}
      />

      <MiddleSection isMobile={toSm} />

      <BubbleWithText
        isMobile={toSm}
        title={t("Dashboard##how credits work##top content##tracking device")}
        subtitle={t(
          "Dashboard##how credits work##top content##identified by IMEI"
        )}
        icon={<OBDIcon />}
      />
    </div>
  );
};

export default TopDialogContent;
